export default __webpack_public_path__ + "static/media/wf.7958ff7c.svg";